export const SHOWING_SETTINGS_QUERY_KEY = ["SHOWING_SETTINGS"] as const;

export const SHOWINGS_LIST_QUERY_KEY = ["SHOWINGS_LIST"] as const;

export const SHOWING_ELIGIBLE_PROPERTIES_QUERY_KEY = [
  "SHOWING_ELIGIBLE_PROPERTIES"
] as const;

export const LEAD_SHOWINGS_QUERY_KEY = (leadId: number | string) =>
  ["LEAD_SHOWINGS", String(leadId)] as const;

export const AVAILABILITY_OVERVIEW_QUERY_KEY = [
  "AVAILABILITY_OVERVIEW"
] as const;

export { CALENDAR_GRANTS_QUERY_KEY } from "api/nylas/queryKeys";

export const RESCHEDULE_REQUEST_AVAILABILITY_QUERY_KEY = (showingId: number) =>
  ["SHOWING_RESCHEDULE_AVAILABILITY", showingId] as const;

export const RESCHEDULE_REQUEST_PREVIEW_QUERY_KEY = (showingId: number) =>
  ["SHOWING_RESCHEDULE_REQUEST_PREVIEW", showingId] as const;
